import React from 'react'
import { connect } from "react-redux"
import PracticeHeader from '../practice/PracticeHeader'
import { withRouter, Link } from 'react-router'
import { fetchPractice } from "../../actions/index"
import FileUpload from '../ui/FileUpload'
import { deleteImage } from '../../actions/images'
import { saveLogo, updateAppPracticeField, savePractice, saveBackground } from '../../actions/practiceAdmin'
import TextareaAutosize from 'react-autosize-textarea';
import PracticeAdminMenu from './PracticeAdminMenu'
import loaderImg from '../practice_admin/images/loader.gif'


const saveStyle = {
	'zIndex': 2,
	'position': 'relative'
}
@connect((store) => {
	return {
    User: store.User.User,
    app: store.app,
    practice_types: [...store.practice_types]
  };
})
class PracticeAdmin extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			"saved": true,
			"loading": true,
			"tipShowing": false,
			"filteredPracticeType": null
		}
		this.ownerAuth = this.ownerAuth.bind(this)
		this.getPractice = this.getPractice.bind(this)
		this.addLogo = this.addLogo.bind(this)
		this.addBackground = this.addBackground.bind(this)
		this.handleInputChange = this.handleInputChange.bind(this)
		this.save = this.save.bind(this)
		this.showTippeds = this.showTippeds.bind(this)
		this.closeTooltip = this.closeTooltip.bind(this)
		this.filterPracticeType = this.filterPracticeType.bind(this);
	}



	componentDidUpdate(nextProps) {
		const { app } = this.props;
		const nextApp = nextProps.app;
    var fetched = false;
    if (this.props.User.token && this.props.User.name != nextProps.User.name) {
      this.getPractice().then(() => {
        this.filterPracticeType();
        this.setState({ loading: false });
      })
      this.ownerAuth()
      fetched = true;
    }

		if (!fetched && app.practice._id !== nextApp.practice._id) {
			this.getPractice() 
		}
    // console.log("DONE")
	}

	componentWillMount() {
    if (this.props.User.token && this.props.User.name != '') {
      this.getPractice().then(() => {
        this.filterPracticeType();
        this.setState({ loading: false });
      })
    }
	}

	componentDidMount() {
		this.showTippeds()
		
	}


	closeTooltip(which) {
		let seenItem = window.localStorage.getItem("seen-" + which) || 0;
		this.setState({
			tipShowing: false
		})

		window.localStorage.setItem("seen-" + which, (seenItem / 1) + 1)

		if (which === "users") {
			this.setState({
				tipShowing: "patients"
			})
		}
		setTimeout(() => {
			this.setState({
				tipShowing: false
			})
		}, 3000);
	}

	componentWillUnmount() {
		const { tipShowing } = this.state;
		tipShowing && this.closeTooltip(tipShowing)
	}

	showTippeds() {
		let seenUsers = window.localStorage.getItem("seen-users") || 0
		let seenPatients = window.localStorage.getItem("seen-patients") || 0

		if (seenUsers / 1 === 1 && seenPatients / 1 === 0) {
			this.setState({
				"tipShowing": "patients",
			})
			return
		}

		if (seenUsers / 1 < 4) {
			this.setState({
				"tipShowing": "users",
			})
			return
		}
		
		setTimeout(() => {
			this.setState({
				tipShowing: false
			})
		}, 3000);
	}

	handleInputChange(e, field) {
		const { dispatch } = this.props;
		this.setState({ "saved": false })
		dispatch(updateAppPracticeField(field, e.target.value))

	}

	save() {
		const { dispatch, app } = this.props;
		dispatch(savePractice(app.practice._id, app.practice)).then(() => {
			this.setState({ "saved": true })
		})
	}


	getPractice() {
		return this.props.dispatch(fetchPractice(this.props.params.name))
	}

	addLogo(img) {
		const { dispatch, app } = this.props;
		// eslint-disable-next-line
		app.practice.logo && deleteImage(app.practice.logo)
		dispatch(saveLogo(img, app.practice._id))
	}

	addBackground(img) {
		const { dispatch, app } = this.props;
		// eslint-disable-next-line
		app.practice.backgroundImg && deleteImage(app.practice.backgroundImg)
		dispatch(saveBackground(img, app.practice._id))
	}

	ownerAuth() {
		const { app, User, params, router } = this.props;
		// is this not an owner of this practice?

		if (!app.authed) return false;

		if (!User.ownPractices
			.find(p => params.name === p.id || params.name === p.slug)) {
			router && router.replace('/');
			return false
		}
		return true
	}

	filterPracticeType(){
		// console.log(this.props.app.practice.practice_type);
		const filteredType = this.props.practice_types.find(practiceType => practiceType.id === this.props.app.practice.practice_type)
		// console.log(filteredType);
		this.setState({ filteredPracticeType: filteredType });
	}

	render() {
		const { app, params } = this.props;
		const { saved, tipShowing, loading } = this.state;
    const origin = window.location.origin;
    let practiceTypeHeader = '';
		if (this.state.filteredPracticeType !== undefined && this.state.filteredPracticeType !== null) {
      practiceTypeHeader = this.state.filteredPracticeType.practice_type;
		}
		if (loading) {
			const divStyle = {
				'paddingTop': '50px',
				'fontSize': '.4em',
				'position': 'fixed',
				'transform': 'translate(-50%, -50%)',
				'top': '40%',
				'left': '50%',
				'display': 'flex',
				'flexDirection': 'column',
				'alignItems': 'center',
				'justifyContent': 'center'
			};

			// Need to style loading
			return (<div>
				<main className={"main"}>
					<div className="padding">
						<h4 style={divStyle}>
							<img src={loaderImg} alt="" />
							<small>Loading</small>
						</h4>
					</div>
				</main>
			</div>);
		}

		return (
      <main className="main practice-page">
        <PracticeHeader
          practiceType={practiceTypeHeader}
          practice={
            app.practice || {
              name: "..."
            }
          }
        ></PracticeHeader>
        <PracticeAdminMenu
          active="home"
          closeTooltip={this.closeTooltip}
          tooltipOpen={tipShowing}
          params={params}
        />
        <div className="page adminPracticeView height100 mb8">
          <div>
            {app.practice.tempSlug ? (
              <div>
                <br />
                <p>
                  Please fill out the practice details. You will be assigned a
                  unique SpecialT URL once approved.
                </p>
              </div>
            ) : null}

            {!app.practice.tempSlug ? (
              <p>
                Public page: {`${origin}/practice/${app.practice.slug}`}
                {/* <Link to={`${origin}/practice/${app.practice.slug}`}>/practice/{app.practice.slug}</Link> */}
                <br />
                <small> (Copy link to share to users)</small>
              </p>
            ) : null}

            {/* <h5>
						{app.practice.name}
					</h5> */}
            <h6>Settings</h6>
            <div className="md-body1 form-field">
              <label>Practice Name</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "name")}
                  value={app.practice.name}
                  type="text"
                  placeholder="Name of Practice"
                />
              </div>
            </div>
            {app.practice._id ? (
              <div className="md-body1 form-field">
                <label>HPCSA Number</label>
                <div>
                  <input
                    className="md-input md-title"
                    autoComplete="off"
                    onChange={e => this.handleInputChange(e, "HPCSA")}
                    value={app.practice.HPCSA}
                    type="text"
                    placeholder="HPCSA Number"
                  />
                </div>
              </div>
            ) : null}

            {app.practice._id ? (
              <div className="md-body1 form-field">
                <label>
                  Logo
                  <FileUpload
                    name={`practice_logo_${app.practice._id}`}
                    path={`images/practices/${app.practice._id}/`}
                    callback={this.addLogo}
                  />
                </label>
                <div>
                  {app.practice.logo ? (
                    <img
                      alt="Logo"
                      style={{
                        maxHeight: "72px"
                      }}
                      src={app.practice.logo.thumb}
                    />
                  ) : null}
                </div>
              </div>
            ) : null}
            {app.practice._id ? (
              <div className="md-body1 form-field">
                <label>
                  Background image
                  <FileUpload
                    name={`practice_background_${app.practice._id}`}
                    path={`images/practices/${app.practice._id}/`}
                    callback={this.addBackground}
                  />
                </label>
                <div
                  style={
                    app.practice.backgroundImg
                      ? {
                          backgroundImage: `url(${app.practice.backgroundImg.scaled})`,
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center center",
                          height: "8em"
                        }
                      : {}
                  }
                ></div>
              </div>
            ) : null}
            {app.practice._id ? (
              <div className="md-body1 form-field">
                <label>Description</label>
                <div>
                  <TextareaAutosize
                    className="md-input"
                    placeholder="Write a description of the practice ..."
                    onChange={e => this.handleInputChange(e, "description")}
                    value={app.practice.description}
                  />
                </div>
              </div>
            ) : null}
            <h5>Contacts</h5>
            <div className="md-body1 form-field">
              <label>Phone</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "phone")}
                  value={app.practice.phone}
                  type="text"
                  placeholder="Phone"
                />
              </div>
            </div>
            <div className="md-body1 form-field">
              <label>Mobile</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "mobile")}
                  value={app.practice.mobile}
                  type="text"
                  placeholder="Mobile"
                />
              </div>
            </div>
            <div className="md-body1 form-field">
              <label>Email</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "email")}
                  value={app.practice.email}
                  type="email"
                  placeholder="Email"
                />
              </div>
            </div>
            {app.practice._id ? (
              <div className="md-body1 form-field">
                <label>www</label>
                <div>
                  <input
                    className="md-input md-title"
                    autoComplete="off"
                    onChange={e => this.handleInputChange(e, "www")}
                    value={app.practice.www}
                    type="text"
                    placeholder="Web site"
                  />
                </div>
              </div>
            ) : null}
            <h5>Address</h5>
            <div className="md-body1 form-field">
              <label>Address</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "address1")}
                  value={app.practice.address1}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
            <div className="md-body1 form-field">
              <label>Address 2</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "address2")}
                  value={app.practice.address2}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
            <div className="md-body1 form-field">
              <label>City</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "city")}
                  value={app.practice.city}
                  type="email"
                  placeholder="City"
                />
              </div>
            </div>
            <div className="md-body1 form-field">
              <label>State/Provence</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "state")}
                  value={app.practice.state}
                  type="text"
                  placeholder="Province/state"
                />
              </div>
            </div>
            <div className="md-body1 form-field">
              <label>Postal code</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "postCode")}
                  value={app.practice.postCode}
                  type="text"
                  placeholder="Postal/zip code"
                />
              </div>
            </div>
            <div className="md-body1 form-field">
              <label>Country</label>
              <div>
                <input
                  className="md-input md-title"
                  autoComplete="off"
                  onChange={e => this.handleInputChange(e, "country")}
                  value={app.practice.country}
                  type="text"
                  placeholder="Country"
                />
              </div>
            </div>

            <br />
            <button
              disabled={saved}
              className="md-button md-primary right link"
              style={saveStyle}
              onClick={this.save}
            >
              Save
            </button>

            {app.practice.approved || true ? null : (
              <button
                className="md-button dark link"
                style={saveStyle}
                onClick={this.submit}
              >
                Submit for approval
              </button>
            )}
            <br />
            <br />
          </div>
        </div>
      </main>
    );
	}
}

export default withRouter(PracticeAdmin);



// WEBPACK FOOTER //
// ./src/components/practice_admin/PracticeAdmin.jsx